export const isNotUndefined = <T>(item: T | undefined): item is T => item !== undefined;

export function uniqueFilter<T extends string>(value: T, index: number, self: readonly T[]): boolean {
	return self.indexOf(value) === index;
}

export function lastItem<T>(array: readonly T[]): T | undefined {
	if (!array || array.length === 0) {
		return undefined;
	}

	return array[array.length - 1];
}
